export enum EmailAddressType {
  TO = 'to',
  CC = 'cc',
  BCC = 'bcc'
}
